export const REFUND_POLICY_BASED_ON_CURRICULUM_COMPLETION = 'based_on_curriculum_completion'; // superseded by REFUND_POLICY_BASED_ON_ASSESSMENT_COMPLETION in cycle 62+
export const REFUND_POLICY_BASED_ON_ASSESSMENT_COMPLETION = 'based_on_assessment_completion';
export const REFUND_POLICY_REFUND_DEADLINE = 'refund_deadline';
